
import { defineComponent, onMounted } from "vue";
import draggable from "vuedraggable";

import state from "@/store/state";
import {
  loadEmojis,
  setDefault,
  shiftEmoji,
  removeEmoji,
  moveLeft,
  moveRight,
  makeCopy
} from "@/store/methods";

import Emoji from "@/components/Emoji.vue";

export default defineComponent({
  name: "EmojiWrapper",
  components: {
    draggable,
    Emoji
  },
  props: {
    editMode: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      state: state
    };
  },
  setup() {
    onMounted(() => {
      if (state.allEmojis.size === 0) {
        loadEmojis();
      }
      if (state.stagingEmojis.length === 0) {
        setDefault();
      }
      // console.log(state.stagingEmojis);
      // console.log(`Loaded emojis: ${state.allEmojis.size.toString()} \n`);
    });

    return {
      setDefault,
      shiftEmoji,
      removeEmoji,
      onMounted,
      moveLeft,
      moveRight,
      makeCopy
    };
  }
});
